import { createSelector } from 'reselect';

import { YES_FLAG } from '../../shared/constants';

export const shadeGridFlagSelector = ({ user }) => user.user && user.user.shadeGridFlag === YES_FLAG;

export const displayZeroSelector = ({ user }) => user.user && user.user.displayZeroFlag === YES_FLAG;

export const clientsSelector = ({ user }) => user.clients;

export const lastClientIdSelector = ({ user }) => user.user?.lastClientId;

export const currentClientSelector = createSelector(
  lastClientIdSelector,
  clientsSelector,
  (lastClientId, clients) => clients.find(({ clientId }) => clientId === lastClientId)
);

export const hideDecimalsSelector = ({ user }) => (user.user && user.user.hideDecimalsFlag === YES_FLAG)
  || false;

export const negativeMinusSelector = ({ user }) => (user.user && user.user.negativeMinusFlag === YES_FLAG)
  || false;

export const isUpdatingPreferencesSelector = ({ user }) => user.isUpdatingPreferences;

export const userSelector = ({ user }) => user.user;

export const formattingOptionsSelector = createSelector(
  hideDecimalsSelector,
  negativeMinusSelector,
  displayZeroSelector,
  (hideDecimals, negativeMinus, shouldDisplayZero) => ({
    hideDecimals, negativeMinus, shouldDisplayZero,
  })
);
